/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SelectedOption/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import BankAccount from './BankAccount/index'
import CreditCard from './CreditCard/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SelectedOption({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/PaymentSources/SelectedOption/Autopay/SelectedOption"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let newPaymentPlanSelectedAutopaySourceValueData = fromData.useDataFormat({ viewPath,
context: 'new_payment_plan',
path: 'selected_autopay_source',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: newPaymentPlanSelectedAutopaySourceValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BankAccount'}>
<BankAccount
  viewPath={`${viewPath}/BankAccount`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreditCard'}>
<CreditCard
  viewPath={`${viewPath}/CreditCard`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}